module.exports = __webpack_public_path__ + "static/img/funs.16da50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/function/funs.png
// module id = Apt6
// module chunks = 0